import { ButtonItem as AKButtonItem, ButtonItemProps } from '@atlaskit/menu';
import React, { forwardRef } from 'react';

type FixedButtonItemProps = ButtonItemProps & {
  onMouseEnter?: (event: React.MouseEvent | React.KeyboardEvent) => void;
  onMouseLeave?: (event: React.MouseEvent | React.KeyboardEvent) => void;
};

const ButtonItem = forwardRef<HTMLElement, FixedButtonItemProps>(function ButtonItem(
  { children, ...props },
  ref
) {
  return (
    <AKButtonItem {...props} ref={ref}>
      {children}
    </AKButtonItem>
  );
});

export default ButtonItem;
